/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React, { useState, useEffect } from 'react';
import './index.scss';
import { IntlProvider } from 'react-intl';
import DefaultErrorBoundary from './components/DefaultErrorBoundary';
import messages from './translations/en.json';
import App from './App';

const Root = (props) => {
  const { token: tokenProp, sites: sitesProp, tokenSubject, sitesSubject } = props || {};
  const [token, setToken] = useState(tokenProp ?? null);
  const [studySites, setStudySites] = useState(sitesProp ?? []);

  // Sync from direct props when host passes token/sites
  useEffect(() => {
    if (tokenProp !== undefined) setToken(tokenProp);
    if (sitesProp !== undefined) setStudySites(sitesProp);
  }, [tokenProp, sitesProp]);

  // Subscribe to observables for reactive updates
  useEffect(() => {
    const unsubscribes = [];
    if (tokenSubject) {
      unsubscribes.push(tokenSubject.subscribe((t) => setToken(t)));
    }
    if (sitesSubject) {
      unsubscribes.push(sitesSubject.subscribe((s) => setStudySites(s)));
    }
    return () => unsubscribes.forEach((unsub) => unsub.unsubscribe());
  }, [tokenSubject, sitesSubject]);

  return (
    <IntlProvider locale="en" messages={messages}>
      <React.StrictMode>
        <DefaultErrorBoundary>
          <App token={token} sites={studySites} />
        </DefaultErrorBoundary>
      </React.StrictMode>
    </IntlProvider>
  );
};

export default Root;
